export default __webpack_public_path__ + "static/media/kast-pv-kv.5220f720.jpg";